import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { AdminUsersPage } from "../features/admin/AdminUsersPage"

// premium-Filter (Dennis-Feedback): "Premium aktiv" / "Ehemals Premium" via
// premium_expires_at (siehe Api::V2::Admin::UsersController#index). Wie bei
// /hotspots (F-033) landet der Filter als Query-Param in der URL statt nur
// im lokalen State — so bleiben Filter+Suche nach Reload/Teilen erhalten.
const adminUsersSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  premium: z.enum(["active", "expired"]).optional().catch(undefined),
  page: z.number().int().positive().optional().default(1).catch(1),
})

export const Route = createFileRoute("/_auth/admin/users")({
  validateSearch: adminUsersSearchSchema,
  component: AdminUsersPage,
})
